import React, { useState, useEffect } from "react";
import AddNewBoard from "./NewBoardModal";
import { withCookies, useCookies } from "react-cookie";
import { Spinner, Button } from "react-bootstrap";
//import configVars from "../config";
import ConfirmationBox from "./ConfirmationBox";
import { useTranslation } from "react-i18next";
import { getAllBoards, deleteBoard } from "../redux/actions/boards";
import { useDispatch, useSelector } from "react-redux";
import { getExpiry } from "../common";
import { Link, Redirect } from "react-router-dom";

const Boards = (props) => {
  const dispatch = useDispatch();
  const allBoards = useSelector((state) => state.boards.myBoardsList);
  const sharedBoards = useSelector((state) => state.boards.sharedBoardsList);

  const [translation] = useTranslation("translations");
  const [show, setShow] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [isEdit, setIsEdit] = useState(false);

  const [cookies] = useCookies(["sustainyou_user_jwt"]);

  async function getBoardsListData() {
    if (cookies.sustainyou_user_jwt) {
      setLoading(true);
      await dispatch(getAllBoards(cookies.sustainyou_user_jwt));
      setLoading(false);
    }
  }
  useEffect(() => {
    let expired = getExpiry("sustainchange_all_boards_expiry");

    async function getBoardsList(userJwt) {
      setLoading(true);
      await dispatch(getAllBoards(userJwt));
      setLoading(false);
    }

    if (cookies.sustainyou_user_jwt) {
      if (cookies.sustainyou_user_jwt && expired) {
        getBoardsList(cookies.sustainyou_user_jwt);
      }
    }
  }, [dispatch, cookies]);

  let userAllBoardsCount = 0;

  if ( allBoards && allBoards.length > 0 ) {
    userAllBoardsCount = userAllBoardsCount + allBoards.length;
  }

  if ( sharedBoards && sharedBoards.length > 0 ) {
    userAllBoardsCount = userAllBoardsCount + sharedBoards.length;
  }

  const handleClose = () => {
    setShow(false);
    setSelectedBoard(null);
  };
  const handleShow = () => setShow(true);

  // const handleEdit = (e, board) => {
  //   e.stopPropagation();
  //   e.preventDefault();
  //   setSelectedBoard(board);
  //   handleShow();
  //   setIsEdit(true);
  // };

  const handleDelete = (e, board) => {
    e.stopPropagation();
    e.preventDefault();
    setSelectedBoard(board);
    handleShowConfirmation();
  };
  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    setSelectedBoard(null);
  };
  const handleShowConfirmation = () => setShowConfirmation(true);

  const handleDeleteBoard = async () => {
    setLoading(true);

    try {
      setLoading(true);
      await dispatch(deleteBoard(selectedBoard?.id));
      setSelectedBoard(null);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }

    handleCloseConfirmation();
  };

  if (!allBoards && !loading) {
    return <Redirect to="/login/?logout=true" />;
  }

  if ( window.location.pathname === "/" ) {
    return (
      <div className="bg-white p-3 pt-2 w-100" style={{height: "336px"}}>

          <div className="d-flex flex-column h-100">
            
            <div className="d-flex align-items-center">
              <h5 className="flex-grow-1">Change boards</h5>
              <span className="display-6">{userAllBoardsCount}</span>
              {/* <Link to="/my-boards" className="text-secondary d-inline-block text-decoration-none" >
                  <span className="pe-2">{translation('my_boards')}</span>
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
              </Link> */}
            </div>
            <p className="opacity-half font-size-medium mb-0 mt-1">Med stöd av en Change board och en guide ökar sannolikheten att lyckas gå från nuläge till nyläge.</p>

            <div className="d-flex flex-column flex-lg-row mt-3">
              <Link className="text-decoration-none col-12 col-lg-6" to={`/change-boards`} >
                <div className="board-wrap cursor-pointer bg-dark-gradient position-relative rounded-3 shadow-lg dashboard me-2" style={{height: "100px"}} >
                <div className="board-overlay position-absolute top-0 left-0 w-100 h-100">
                  <div className="board-inner p-3 d-flex flex-column h-100">
                    <h6 className="board-title text-white d-flex justify-content-between">
                      <span>Se alla</span>
                    </h6>
                  </div>
                </div>
              </div>
              </Link>
              <button type="button" className="text-decoration-none p-0 border-0 col-12 col-lg-6 mt-3 mt-lg-0"  onClick={() => {setSelectedBoard(null); handleShow();}}>
                    <div
                      className="board-wrap cursor-pointer bg-dark-gradient position-relative rounded-3 shadow-lg dashboard" style={{height: "100px" }} >
                      <div className="board-overlay position-absolute top-0 left-0 w-100 h-100">
                        <div className="board-inner p-3 d-flex flex-column h-100">
                          <h6 className="board-title text-white d-flex justify-content-between">
                            <span>Skapa ny</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                </button>

              {/* <Link to="/my-boards" className="btn btn-halite-blue rounded-pill font-size-medium me-2" >
                  <span className="pe-2">{translation('my_boards')}</span>
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
              </Link>
              <button type="button" className="btn btn-halite-blue rounded-pill font-size-medium" onClick={() => {setSelectedBoard(null); handleShow();}}>
              <span className="pe-2">{translation('board_form.add_board')}</span>
                <i className="fa fa-plus" aria-hidden="true"></i>
              </button> */}
            </div>

            {/* <div className="d-flex h-100 justify-content-center align-items-center">
              <span className="display-1">{userAllBoardsCount}</span>
            </div> */}

          </div>

          {allBoards && allBoards?.length < props?.boardsLimit &&
            <AddNewBoard
            show={Boolean(show)}
            handleClose={handleClose}
            selectedBoard={selectedBoard}
            memberships={props.memberships}
          />
          }
          

          <ConfirmationBox
            show={Boolean(showConfirmation)}
            handleClose={handleCloseConfirmation}
            title={translation("delete_board")}
            message={`${translation("delete_board_warning")} ${
              selectedBoard?.title
            }?`}
            confirmationAction={handleDeleteBoard}
            loading={loading}
          />
          
      </div>
    )
  }

  return (
    <div className="boards-wrapper d-inline-block w-100">
      {loading ? (
        <div className="d-flex justify-content-center mt-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div className="container-fluid board-page">
          {window.location.pathname !== "/" && (
            <div className="row">
              <div className="col-10"></div>
              <div className="col-2 d-flex justify-content-center align-items-center">
                <Button
                  variant="downriver"
                  onClick={() => getBoardsListData()}
                  className="text-white rounded refresh-btn boards-btn"
                  size="sm"
                >
                  {"Uppdatera"}
                </Button>
              </div>
            </div>
          )}

          {(!props.displayType || props.displayType !== "team-boards") &&
            window.location.pathname !== "/" && (
              <div className="row pb-5">
                
                <div className="col-12">
                  <h2>Skapade av mig</h2>
                  <p className="opacity-half font-size-medium m-0">Dessa Change boards har du skapat och är ägare av även när du delat en board med andra.</p>
                </div>

                {allBoards?.length > 0 ? (
                  allBoards?.map((board, index) => {
                    return (
                      <Link
                        className="col-12 col-md-6 col-lg-auto mt-4 mx-md-2 px-md-0"
                        key={index}
                        to={`/board/${board.id}`}
                      >
                        <div
                          className="board-wrap my-boards-wrap cursor-pointer bg-dark-gradient position-relative rounded-3 shadow-lg"
                          style={{
                            height: "200px",
                            maxWidth: "400px",
                          }}
                        >
                          <div className="board-overlay position-absolute top-0 left-0 w-100 h-100">
                            <div className="board-inner p-3 d-flex flex-column h-100">
                              <h3 className="board-title text-white d-flex justify-content-between">
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: board.title,
                                  }}
                                ></span>
                                <div>
                                  <div className="d-flex justify-content-end">
                                    <Link
                                      to={`/board/${board.id}/settings/`}
                                      className="m-1 bg-primary border-0 btn btn-sm"
                                    >
                                      <i className="fa fa-edit  text-white"></i>
                                    </Link>
                                    <Button
                                      size="sm"
                                      className="m-1 bg-secondary border-0"
                                      onClick={(e) => handleDelete(e, board)}
                                    >
                                      <i className="fa fa-trash  text-white"></i>
                                    </Button>
                                  </div>
                                </div>
                              </h3>

                              <div className="board-users-wrap d-flex flex-grow-1 align-items-end">
                                <div className="board-users-inner d-flex align-items-center">
                                  {board?.users?.length > 0 &&
                                    board?.users
                                      ?.slice(0, 4)
                                      .map((boardUser, index) => {
                                        return (
                                          <div
                                            className="board-user-avatar"
                                            key={index}
                                          >
                                            <img
                                              src={boardUser.user_avatar}
                                              alt={boardUser.name}
                                              className="rounded-circle"
                                              style={{
                                                height: "25px",
                                                width: "25px",
                                              }}
                                            />
                                          </div>
                                        );
                                      })}

                                  {board?.users?.length > 4 && (
                                    <span className="ms-1 text-white font-size-medium">
                                      +{board?.users?.length - 4}{" "}
                                      {translation("members")}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                  })
                ) : (
                  <div className="container-fluid px-3">
                    <div className="d-flex justify-content-center mt-5">
                      <h4> {translation("boards.no_board")}</h4>
                    </div>
                  </div>
                )}
                {allBoards?.length < props?.boardsLimit && (
                  <div
                    className="col-12 col-md-6 col-lg-auto mt-4"
                    onClick={() => {
                      setSelectedBoard(null);
                      handleShow();
                    }}
                  >
                    <div
                      className="board-wrap cursor-pointer bg-white position-relative rounded-3 border border-3 shadow"
                      style={{
                        height: "200px",
                        maxWidth: "400px",
                        minWidth: "350px",
                      }}
                    >
                      <div className="d-flex h-100 w-100 justify-content-center align-items-center">
                        <i
                          className="fa fa-plus fa-4x text-halite-blue fa-thin"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                  </div>
                )}

              {props?.capabilities && props?.capabilities.includes('team_boards') &&

                <div className="col-12">
                  <div className="row">

                  <div className="col-12 mt-4">
                    <h2>Inbjuden av andra</h2>
                    <p className="opacity-half font-size-medium m-0">Här finns de Change boards som andra skapat och bjudit in dig till.</p>
                  </div>

                    {sharedBoards?.length > 0 ? (
                      sharedBoards?.map((board, index) => {
                        return (
                          <Link
                            className="col-12 col-md-6 col-lg-auto mt-4 text-decoration-none mx-md-2 px-md-0"
                            key={index}
                            to={`/board/${board.id}`}
                          >
                            <div
                              className="board-wrap team-boards-wrap cursor-pointer bg-dark-gradient position-relative rounded-3 d-flex flex-column justify-content-between shadow-lg"
                              style={{
                                height: "200px",
                                maxWidth: "400px",
                              }}
                            >
                              <div className="board-overlay top-0 left-0 w-100 h-100">
                                <div className="board-inner p-3 d-flex flex-column h-100">
                                  <h3 className="board-title text-white text-capitalize d-flex justify-content-between align-item-center flex-grow-1">
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: board.title,
                                      }}
                                    ></span>
                                  </h3>
                                  <div className="board-users-wrap d-flex">
                                    {board?.owner?.avatar && (
                                      <div className="board-user-avatar">
                                        <img
                                          src={board?.owner?.avatar}
                                          alt="alternate"
                                          className="rounded-circle"
                                          style={{
                                            height: "25px",
                                            width: "25px",
                                          }}
                                        />
                                      </div>
                                    )}

                                    {board?.users?.length > 0 &&
                                      board?.users
                                        ?.slice(0, 4)
                                        .map((boardUser, index) => {
                                          return (
                                            <div
                                              className="board-user-avatar"
                                              key={index}
                                            >
                                              <img
                                                src={boardUser.user_avatar}
                                                alt={boardUser.name}
                                                className="rounded-circle"
                                                style={{
                                                  height: "25px",
                                                  width: "25px",
                                                }}
                                              />
                                            </div>
                                          );
                                        })}

                                    {board?.users?.length > 4 && (
                                      <span className="ms-2">
                                        +{board?.users?.length - 4} members
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        );
                      })
                    ) : (
                      <div className="container-fluid px-3">
                        <div className="d-flex justify-content-center mt-5">
                          <h4> {translation("boards.no_board")}</h4>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

              }

                

              </div>
            )}

          
        </div>
      )}

      {allBoards && (allBoards?.length < props?.boardsLimit ) &&
        <AddNewBoard
        show={Boolean(show)}
        handleClose={handleClose}
        selectedBoard={selectedBoard}
        memberships={props.memberships}
      />
      }

      <ConfirmationBox
        show={Boolean(showConfirmation)}
        handleClose={handleCloseConfirmation}
        title={translation("delete_board")}
        message={`${translation("delete_board_warning")} ${
          selectedBoard?.title
        }?`}
        confirmationAction={handleDeleteBoard}
        loading={loading}
      />
    </div>
  );
};

export default withCookies(Boards);
